import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import Plataforma from './storeModules/Plataforma';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

Vue.use(Vuex);
Vue.config.devtools = true;

const storeInstance = new Vuex.Store({
  state: {},
  actions: {},
  modules: {
    PF: Plataforma
  },
  mutations: {},
  plugins: [vuexLocalStorage.plugin]
});

export default function (/* { ssrContext } */) {
  const Store = storeInstance;
  return Store;
}

export { storeInstance };
